import { ProductsActionsList, ProductsOperatorsForCondition } from "../../models";

export const ACTIONS_LIST: ProductsActionsList[] = [
    // {
    //     id: "media_file",
    //     name: "Выгрузить медиафайл",
    //     action: "DOWNLOAD_MEDIA_FILES"
    // },
    {
        id: "download_product_files",
        name: "Выгрузить данные по товару",
        action: "DOWNLOAD_PRODUCT_DATA"
    },
    {
        id: "certificate",
        name: "Прикрепить сертификат",
        action: "PRODUCTS_CERTIFICATE_CREATE"
    },
    {
        id: "attritube_edit",
        name: "Редактировать атрибуты",
        action: "ATTRIBUTE_VALUE_UPDATE"
    },
    {
        id: "spicification_unload",
        name: "Выгрузить по спецификации",
        action: "LIST_FOR_DOWNLOADING_SPECIFICATIONS"
    },
    {
        id: "delete_selected",
        name: "Удалить выбранное",
        action: "PRODUCTS_DELETE"
    },
]

export const OPERATORS_FOR_CONDITION: ProductsOperatorsForCondition[] = [
    {
        id: 'AND',
        name: 'И'
    },
    {
        id: 'OR',
        name: 'Или'
    }
]